import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core'

import AddUsers from './AddUsers'
import EnableMeetings from './EnableMeetings'

import Spinner from 'spinner'
import API from '../util/api_v5'

const styles = theme => ({
	app: {
		fontFamily: 'Montserrat, Helvetica, arial, sans-serif !important',
		paddingBottom: 80,
		'& .MuiInputBase-input': {
			fontFamily: 'Montserrat, Helvetica, arial, sans-serif !important'
		},
		'& *': {
			fontFamily: 'Montserrat, Helvetica, arial, sans-serif !important'
		}
	},
	spinnerStyle: {
		paddingTop: 20,
		margin: 'auto',
		width: 100
	}
})

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => ({})

class App extends Component {

	state = {
		loaded: false,
		addingUser: false,
		enablingMeetings: true,
		meetingsEnabled: false,
		plan: 'MEETINGS_BASE',
		domainEntry: '',
		businessNameEntry: '',
		users: []
	}

	componentDidMount = async () => {
		this.setState({ enablingMeetings: true })
		let videoConfig = await API.getConfig()
		if (videoConfig.enabled) {
			let plan = videoConfig.plan_code || this.state.plan
			this.setState({ meetingsEnabled: true, addingUser: true, loaded: true, plan })
			let users = await API.listUsers()
			users = (users && users.users) ? users.users : []
			this.setState({ users, addingUser: false, businessNameEntry: videoConfig.business })
			this.changeDomainEntry(videoConfig.domain)
		} else {
			this.setState({ enablingMeetings: false, loaded: true })
		}
	}

	changeDomainEntry = value => {
		let domain = value.split(' ').join('_').toLowerCase()
		if (this.validateUrl(`https://${domain}.com`) || !domain) {
			this.setState({ domainEntry: domain })
		}
	}

	validateUrl = value => {
		let pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
			'((([a-z\\d]([a-z\\d-]*[a-z\\d\\_])*)\\.?)+[a-z]{2,}|' + // domain name
			'((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
			'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
			'(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
			'(\\#[-a-z\\d_]*)?$', 'i') // fragment locator
		return pattern.test(value)
	}

	setMeetingsEnabled = meetingsEnabled => this.setState({ meetingsEnabled })
	setEnablingMeetings = enablingMeetings => this.setState({ enablingMeetings })
	setAddingUser = addingUser => this.setState({ addingUser })
	updateUsers = users => this.setState({ users })
	updateBusinessNameEntry = businessNameEntry => this.setState({ businessNameEntry })
	updatePlan = plan => this.setState({ plan })

	render() {
		const { classes } = this.props
		return (
			this.state.loaded ?
				<div className={classes.app}>
						<AddUsers
							users={this.state.users}
							addingUser={this.state.addingUser}
							businessNameEntry={this.state.businessNameEntry}
							domainEntry={this.state.domainEntry}
							plan={this.state.plan}
							extensions={this.props.extensions}
							mappedExtensions={this.props.mappedExtensions}
							setAddingUser={this.setAddingUser}
							updateUsers={this.updateUsers}
							updateBusinessNameEntry={this.updateBusinessNameEntry}
							updatePlan={this.updatePlan}
							setMeetingsEnabled={this.setMeetingsEnabled}
							isMeetingsEnabled={this.state.meetingsEnabled}
							changeDomainEntry={this.changeDomainEntry}
						/>
				</div>
				: <div className={classes.spinnerStyle}><Spinner /></div>
		)
	}
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(App))